import Vue from 'vue'

export default {
  getGiftCards (pageNumber, perPage) {
    var params = `page=${pageNumber}&per_page=${perPage}`
    return Vue.prototype.$http.get(`/public_access/gift_cards?${params}`)
  },

  getGiftCardByUrl (domainName) {
    var hostname = domainName || window.location.hostname
    var hostnameFilter = `url_site=${hostname}`
    var urlLink = `/public_access/gift_cards/find_by_url_site?${hostnameFilter}`

    return Vue.prototype.$http.get(urlLink)
  },

  getGiftCardsByUrl (domainName, pageNumber, perPage) {
    var hostname = domainName || window.location.hostname
    var hostnameFilter = `url_site=${hostname}`
    var pageParam = `page=${pageNumber}`
    var perPageParam = `per_page=${perPage}`
    var urlLink = `/public_access/gift_cards/find_by_url_site?${pageParam}&${perPageParam}&${hostnameFilter}`

    return Vue.prototype.$http.get(urlLink)
  },

  getGiftCard (giftCardId) {
    return Vue.prototype.$http.get(`/public_access/gift_cards/${giftCardId}`)
  },

  sendMessageToOwner (giftCardId, userContact) {
    return Vue.prototype.$http.post(`/public_access/gift_cards/${giftCardId}/send_message_to_owner`, { user_contact: userContact })
  }
}
